export default __webpack_public_path__ + "static/media/icon_social-facebook.eb157dd2.svg";